import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'App';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from 'assets/utils/ScrollToTop';
import store from 'store/store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter basename='/'>
        <ScrollToTop />
        <Provider store={store}>
            <App />
        </Provider>
    </BrowserRouter>
);
